// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"95ef658d","455":"ae48f55f","977":"95fe6034"}[chunkId] + ".chunk.js";
};